import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { InvitesManager } from "@/features/admin/components/invites-manager";
import { PageContainer } from "@fleet/ui";

function AdminInvitesPage() {
  return (
    <PageContainer maxWidth="4xl">
      <InvitesManager />
    </PageContainer>
  );
}

export const adminInvitesRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/invites",
  component: AdminInvitesPage,
});
